import { i as e } from "./chunk-lit-CcXdLsKL.js";
import { n as t } from "./chunk-BaseElement-4dmD0u1I.js";
import { c as n, i as r, s as i, t as a } from "./chunk-decorate-BqIm0Y5d.js";
import { t as o } from "./chunk-WithApiClient-LBUb3w-j.js";
import { t as s } from "./chunk-task-DYCHiFVt.js";
import { t as c } from "./chunk-unsafe-html-DvgjoXho.js";
//#region src/entry/core/core-dynamic-product-card.ts
var l = "#graphql\n  fragment ProductVariantNode on ProductVariant {\n    product {\n      handle\n    }\n  }\n\n  query getProductVariantsFromNode($id: ID!) {\n    node(id: $id) {\n      id\n      ...ProductVariantNode\n    }\n  }\n", u = {}, d = {}, f = class extends o(t) {
	constructor(...e) {
		super(...e), this.template = "product-card", this.urlPostfix = "", this.checkIfResponseHasLayout = (e) => e.match(/html|body/), this._loadVariantByIdTask = new s(this, {
			task: async ([e]) => {
				if (!e) throw Error("No variantId provided");
				if (d[e]) return d[e];
				let { node: t } = await this.$api.client.storefront({ body: {
					query: l,
					variables: { id: `gid://shopify/ProductVariant/${e}` }
				} });
				if (t && "product" in t) return d[e] = t.product.handle, d[e];
				throw Error("No product handle found");
			},
			args: () => [this.variantId]
		}), this.loadProductHandleView = new s(this, {
			task: async ([e]) => {
				if (!e) throw Error("No handle provided");
				if (u[this.cacheKey]) return u[this.cacheKey];
				let t = await this.$api.client.shopify(`products/${e}`, {
					method: "GET",
					headers: { "Content-Type": "text/html" }
				}, { params: {
					view: this.template,
					layout: "none",
					...this.variantId && { variant: this.variantId }
				} });
				if (this.checkIfResponseHasLayout(t)) throw Error("Invalid response");
				if (t) return u[this.cacheKey] = t, t;
				throw Error("No product found");
			},
			args: () => [this.handle || this._loadVariantByIdTask.value, this.variantId]
		});
	}
	createRenderRoot() {
		return this;
	}
	get cacheKey() {
		return `${this.handle}-${this.variantId}-${this.template}`;
	}
	_renderPostfix() {
		if (window.__VENDORS__ && !window.__VENDORS__.nosto.enabled || !this.urlPostfix) return;
		let e = Array.from(this.productUrls);
		if (e.length !== 0) for (let t of e) {
			let e = t;
			if (e && (e.href || e.getAttribute("product-url"))) {
				let t = new URL(e.href || e.getAttribute("product-url")), n = this.urlPostfix.split("=");
				n.length === 2 ? t.searchParams.append(n[0], n[1]) : console.error("urlPostfix does not contain exactly one \"=\" character."), e.href ? e.href = t.toString() : e.setAttribute("product-url", t.toString());
			}
		}
	}
	async updated() {
		this._renderPostfix();
	}
	render() {
		return e`
      ${this.loadProductHandleView.render({ complete: (t) => {
			if (t) return this.setAttribute("data-loaded", "true"), e`${c(t)}`;
		} })}
    `;
	}
};
a([i({
	type: String,
	attribute: "variant-id"
})], f.prototype, "variantId", void 0), a([i({ type: String })], f.prototype, "handle", void 0), a([i({ type: String })], f.prototype, "template", void 0), a([i({
	type: String,
	attribute: "url-postfix"
})], f.prototype, "urlPostfix", void 0), a([r("[data-product-url]")], f.prototype, "productUrls", void 0), f = a([n("dynamic-product-card")], f);
//#endregion
export { f as DynamicProductCard };
